import styled from "@emotion/styled";
import { mq } from "../../Theme";
import { mapColor } from "../textUtils";
var TertiaryTextWrapper = /*#__PURE__*/ styled("p", {
    target: "efjwu630"
})("font-size:0.813rem;font-weight:600;text-transform:uppercase;line-height:1.538em;", mq("lg"), "{font-size:0.938rem;line-height:1.467em;}color:", function(param) {
    var textColor = param.textColor, theme = param.theme;
    return mapColor(theme, textColor);
}, ";");
export { TertiaryTextWrapper };
